import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SalonReviews from "./SalonReviews";

const SalonReviewsDialog = ({ open, onClose, reviews }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                Reviews
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Box sx={{ mt: 1 }}>
                    <SalonReviews reviews={reviews} />
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default SalonReviewsDialog;
